import { render, staticRenderFns } from "./physical-goods.vue?vue&type=template&id=fe0da9d6&scoped=true&"
import script from "./physical-goods.vue?vue&type=script&lang=js&"
export * from "./physical-goods.vue?vue&type=script&lang=js&"
import style0 from "./physical-goods.vue?vue&type=style&index=0&id=fe0da9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0da9d6",
  null
  
)

export default component.exports